import customerInstance from '../../instance'

const deleteDeliveryConfigPolygon = (id) => {
  return customerInstance.delete('/deliveryPolygonConfigs/' + id)
}

export default deleteDeliveryConfigPolygon
